module.exports = {
  services: {
    badge: "Сервисы",
    title: "Сервисы",
    subtitle: "Минимальная страница сервисов.",
    summaryTitle: "Что здесь",
    summaryText: "Раздел можно дополнять блоками и кейсами.",
    summaryPoints: ["Аудит", "Поддержка", "Интеграции"],
    cardsTitle: "Направления",
    cardsSubtitle: "Данные рендерятся по массиву карточек.",
    cards: [
      { icon: "fas fa-network-wired", title: "Сети", text: "Короткое описание." },
      { icon: "fas fa-cloud", title: "Облако", text: "Короткое описание." },
      { icon: "fas fa-user-shield", title: "Безопасность", text: "Короткое описание." }
    ],
    listTitle: "Формат работы",
    listSubtitle: "Можно легко добавлять и убирать пункты.",
    listItems: ["Поддержка", "Внедрение", "Сопровождение"],
    stats: [
      { value: "3", label: "линии поддержки" },
      { value: "24/7", label: "доступность" }
    ],
    ctaTitle: "Нужна консультация?",
    ctaText: "Минимальный заполнитель для раздела сервисов.",
    primaryHref: "/pages/contact",
    primaryLabel: "Связаться",
    secondaryHref: "/pages/portal",
    secondaryLabel: "Portal",
    processTitle: "",
    processSubtitle: "",
    process: [
      { num: "01", icon: "fas fa-search", title: "", text: "" },
      { num: "02", icon: "fas fa-drafting-compass", title: "", text: "" },
      { num: "03", icon: "fas fa-cogs", title: "", text: "" },
      { num: "04", icon: "fas fa-check-circle", title: "", text: "" }
    ]
  }
};